import type { ActivityResource } from "api/generated";
import type { TeacherStudentActivity } from "portfolio/types";
import { portfolioActivityFromDto } from "./portfolioActivity.mapper";
import { portfolioShallowStudentFromDto } from "./portfolioShallowStudent.mapper";

export const teacherStudentActivityFromDto = (
  data: ActivityResource,
): TeacherStudentActivity => ({
  ...portfolioActivityFromDto(data.activity),
  student: portfolioShallowStudentFromDto(data.student),
});
